import React, { useState } from "react";
import { BoxFiltros2 } from "../Helper/BoxFiltros2";
import { useBox } from "../Helper/useBox";
import { GetKey } from "../Actions/GetContainer";
import request from "../../../Helpers/API";
import {
  AgruparLineasER,
  GetFechaActual,
  GetFechaActualAnterior,
  formatoFecha,
} from "../Actions/ActionEstadoResultados";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { EstadoResultadosGrafica } from "./EstadoResultadosGrafica";
import { GetMonthNameByNumber } from "../Helper/GetMonthNameByNumber";
import { FiltroER } from "../Helper/FiltroER";
import { useSelector } from "react-redux";
import { ERProyeccionesVentasScreen } from "./ERProyeccionVentasScreen";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { AyudaModal } from "./AyudaModal";

export const EstadoResultadosScreen = () => {
  const fechaActual = new Date();
  const ejercicioActual = fechaActual.getFullYear();
  const mesActual = fechaActual.getMonth() + 1;
  const history = useHistory();
  const [titulo, setTitulo] = useState("ESTADO DE RESULTADOS");
  const [mostrarVentas, setMostrarVentas] = useState(false);
  const [cargarVentas, setCargarVentas] = useState(false);
  const [nomEscenario, setNomEscenario] = useState("");
  const [subtitulo, setSubtitulo] = useState("Escenario 1");
  const [openModal, setOpenModal] = useState(false);
  const [seccion, setSeccion] = useState("estado_resultados");

  const onHome = () => {
    history.push("/Finanzas/Main");
  };
  const storedState =
    JSON.parse(localStorage.getItem("dashboard_filtro")) || {};

  const [boxstate, setBoxState] = useBox({
    ejercicio: storedState.ejercicio || ejercicioActual,
    mesInicio: storedState.periodoinicio || 1,
    mesFin: storedState.periodofin || mesActual,
    ejercicioinicio: storedState.ejercicio || ejercicioActual,
    periodoinicio: storedState.periodoinicio || "1",
    ejerciciofin: storedState.ejercicio || ejercicioActual,
    periodofin: storedState.periodofin || mesActual,
    arraysucursal: [],
    comparacion: 'R',
    escenario: 'A',
    arraydepartamento: [],
    pv: { adr: [], sucursal: [], departamento: [] },
    visualizacion: "1",
  });
  const location = useLocation();
  const permisos = location.state;
  const idSucursalUnicos = [
    ...new Map(
      permisos.map((item) => [item.idsucursal, { idsucursal: item.idsucursal }])
    ).values(),
  ];
  const idDepartamentoUnicos = [
    ...new Map(
      permisos.map((item) => [
        item.iddepartamento,
        { iddepartamento: item.iddepartamento },
      ])
    ).values(),
  ];
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [state, setState] = useState({
    subtitulo: "",
    data: [],
    periodoactual: "",
    periodoanterior: "",
    visualizacion: "",
  });
  const [tipo_reporte, setTipoReporte] = useState("1");
  const [infoGrafica, setInfoGrafica] = useState();

  const [visualizacion, setVisualizacion] = useState("1");

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    const cargarDatos = async () => {
      const fechaActual = new Date();
      const ejercicioActual = boxstate.ejercicio || fechaActual.getFullYear();
      const mesActual = boxstate.periodofin || fechaActual.getMonth() + 1;

      const fechainicio = new Date(
        boxstate.ejercicioinicio,
        boxstate.periodoinicio - 1,
        1
      );
      const fechafin = new Date(
        boxstate.ejercicioinicio,
        boxstate.periodofin - 1,
        1
      );

      const post = {
        fechainicio: fechainicio.toISOString(),
        fechafin: fechafin.toISOString(),
        escenario: boxstate.escenario,
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
        sucursal:
          GetKey(boxstate.pv.sucursal, ["idsucursal"]) ||
          GetKey(idSucursalUnicos, ["idsucursal"]),
        departamento:
          GetKey(boxstate.pv.departamento, ["iddepartamento"]) ||
          GetKey(idDepartamentoUnicos, ["iddepartamento"]),
      };
      try {
        const result = await request.post(
          "FEstadoResultados/GetEstadoResultadosByDireccionRolado",
          post
        );
        var newarray = [];
        var grupos = AgruparLineasER(result);
        grupos.forEach((item) => {
          newarray = [
            ...newarray,
            {
              depto: item,
              data: result.filter((x) => x.departamento == item),
            },
          ];
        });

        setState({
          ...state,
          data: newarray,
          subtitulo: `De ${formatoFecha(fechainicio)} al ${formatoFecha(
            fechafin
          )}`,
          periodoactual: GetFechaActual(
            ejercicioActual,
            ejercicioActual,
            boxstate.periodoinicio,
            mesActual
          ),
          periodoanterior: GetFechaActualAnterior(
            ejercicioActual,
            ejercicioActual,
            boxstate.periodoinicio,
            mesActual
          ),
          visualizacion: boxstate.visualizacion,
        });
        if (
          boxstate.periodoinicio === boxstate.periodofin &&
          boxstate.ejercicioinicio === boxstate.ejerciciofin
        ) {
          setTitulo(
            `ESTADO DE RESULTADOS ${GetMonthNameByNumber(
              boxstate.periodoinicio
            ).toUpperCase()} ${boxstate.ejercicioinicio}`
          );
        } else {
          setTitulo(
            `ESTADO DE RESULTADOS ${GetMonthNameByNumber(
              boxstate.periodoinicio
            ).toUpperCase()} ${boxstate.ejercicioinicio
            } - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejerciciofin
            }`
          );
        }
        if (nomEscenario) {
          setSubtitulo(nomEscenario.toUpperCase());
        }
        setLoader({ ...loader, mostrar: false });
      } catch (error) {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Error", "Hubo un problema al cargar los datos.", "error");
      }
    };

    cargarDatos();
  }, []);

  const BoxClick = () => {

    setLoader({ ...loader, mostrar: true });
    return new Promise((res, req) => {
      if (
        boxstate.ejercicioinicio === undefined ||
        boxstate.ejercicioinicio === null ||
        boxstate.ejercicioinicio === "" ||
        boxstate.ejercicioinicio === "0" ||
        boxstate.ejercicioinicio === 0
      ) {
        req("Favor de agregar el ejercicio de inicio");
        return;
      }
      if (
        boxstate.periodoinicio === undefined ||
        boxstate.periodoinicio === null ||
        boxstate.periodoinicio === "" ||
        boxstate.periodoinicio === "0" ||
        boxstate.periodoinicio === 0
      ) {
        req("Favor de agregar el periodo de inicio");
        return;
      }
      if (
        boxstate.ejerciciofin === undefined ||
        boxstate.ejerciciofin === null ||
        boxstate.ejerciciofin === "" ||
        boxstate.ejerciciofin === "0" ||
        boxstate.ejerciciofin === 0
      ) {
        req("Favor de agregar el ejercicio fin");
        return;
      } else if (
        Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin) && tipo_reporte !== "3"
      ) {
        req("El ejercicio de inicio debe ser menor o igual al ejercicio final");
        setLoader({ ...loader, mostrar: false });
        return;
      }
      if (
        boxstate.periodofin === undefined ||
        boxstate.periodofin === null ||
        boxstate.periodofin === "" ||
        boxstate.periodofin === "0" ||
        boxstate.periodofin === 0
      ) {
        req("Favor de indicar el periodo final");
        return;
      } else if (
        Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
        Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
      ) {
        req("El periodo de inicio no puede ser mayor a l periodo fin");
        return;
      }
      // if (boxstate.visualizacion === 1) {
      const fechainicio = new Date(
        boxstate.ejercicioinicio,
        Number(boxstate.periodoinicio) - 1,
        "01"
      );
      const fechafin = new Date(
        boxstate.ejerciciofin,
        Number(boxstate.periodofin) - 1,
        "01"
      );

      if (tipo_reporte === "3") {
        setMostrarVentas(true)
        setLoader({ ...loader, mostrar: false });
        setSeccion("estado_resultados_proyeccion");
        return
        // history.push("/Finanzas/ProyeccionesVentas", {
        //   sucursales: permisos
        // });
      }

      setMostrarVentas(false)

      const post = {
        fechainicio: fechainicio.toISOString(),
        fechafin: fechafin.toISOString(),
        escenario: boxstate.escenario,
        adr: GetKey(boxstate.pv.adr, ["idadr"]),
        sucursal: GetKey(boxstate.pv.sucursal, ["idsucursal"]) || "0",
        // GetKey(idSucursalUnicos, ["idsucursal"]),
        departamento:
          GetKey(boxstate.pv.departamento, ["iddepartamento"]) || "0",
        // GetKey(idDepartamentoUnicos, ["iddepartamento"]),
      };
      setState({
        ...state,
        data: [],
      });
      const ruta =
        tipo_reporte === "1"
          ? "FEstadoResultados/GetEstadoResultadosByDireccionRolado"
          : "FEstadoResultados/GetEstadoResultadosEbitda";
      Promise.all([request.post(ruta, post)])
        .then(([result, result2]) => {
          setSeccion(
            tipo_reporte === "1"
              ? "estado_resultados"
              : tipo_reporte === "2"
                ? "ebitda"
                : ""
          );
          res("");
          var newarray = [];
          var grupos = AgruparLineasER(result);
          grupos.forEach((item) => {
            newarray = [
              ...newarray,
              {
                depto: item,
                data: result.filter((x) => x.departamento == item),
              },
            ];
          });

          setState({
            ...state,
            data: newarray,
            subtitulo: `De ${formatoFecha(fechainicio)} al ${formatoFecha(
              fechafin
            )}`,
            periodoactual: GetFechaActual(
              boxstate.ejercicioinicio,
              boxstate.ejerciciofin,
              boxstate.periodoinicio,
              boxstate.periodofin
            ),
            periodoanterior: GetFechaActualAnterior(
              boxstate.ejercicioinicio,
              boxstate.ejerciciofin,
              boxstate.periodoinicio,
              boxstate.periodofin
            ),
          });
          setInfoGrafica(result2);
          setVisualizacion(boxstate.visualizacion);
          if (
            String(boxstate.periodoinicio) === String(boxstate.periodofin) &&
            String(boxstate.ejercicioinicio) === String(boxstate.ejerciciofin)
          ) {
            setTitulo(
              `ESTADO DE RESULTADOS ${GetMonthNameByNumber(
                boxstate.periodoinicio
              ).toUpperCase()} ${boxstate.ejercicioinicio}`
            );
          } else {
            setTitulo(
              `ESTADO DE RESULTADOS ${GetMonthNameByNumber(
                boxstate.periodoinicio
              ).toUpperCase()} ${boxstate.ejercicioinicio
              } - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejerciciofin
              }`
            );
          }
          setSubtitulo(nomEscenario);
          setLoader({ ...loader, mostrar: false });
        })
        .catch((err) => {
          req(JSON.stringify(err));
          setLoader({ ...loader, mostrar: false });
        });
    });
  };
  const PDFDownloadButton = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      data: state.data,
      subtitulo: state.subtitulo,
      periodoactual: state.periodoactual,
      periodoanterior: state.periodoanterior,
      region: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal,
    };
    request
      .post(`FEstadoResultados/ReportePDF`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ESTADO DE RESULTADOS", JSON.stringify(error), "error");
      });
  };

  const onGeneraExcel = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      data: state.data,
      subtitulo: state.subtitulo,
      periodoactual: state.periodoactual,
      periodoanterior: state.periodoanterior,
      region: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal,
      departamento: boxstate.pv.departamento,
    };
    request
      .post("FEstadoResultados/GenerarExcel", post)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const onDescargarExcelTodos = () => {
    setLoader({ ...loader, mostrar: true });

    const post = {
      fechainicio: "2026-01-01",
      fechafin: "2026-01-01",
      escenario: "A",
      adr: "1,2",
      sucursal: "0",
      // GetKey(idSucursalUnicos, ["idsucursal"]),
      departamento:
        "0",
      // GetKey(idDepartamentoUnicos, ["iddepartamento"]),
    };
    request
      .post("FEstadoResultados/GenerarExcelTodos", post)
      .then(({ documento, filename }) => {

      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };


  const getIndicadorClass = (indicador) => {
    switch (indicador) {
      case "V":
        return "indicador-verde";
      case "A":
        return "indicador-amarillo";
      case "R":
        return "indicador-rojo";
      default:
        return "";
    }
  };
  const { empleado } = useSelector((store) => store.usuario);
  return (
    <PlantillaScreen
      // titulo={tipo_reporte === "3" ? tituloVentas : titulo}
      titulo={titulo}
      className={"estado-resultados-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="estado-resultados-contenedor-filtros">
        <div className="estado-resultados-regresar" onClick={() => onHome()}>
          <ArrowBackIcon /> Regresar
        </div>
        <FiltroER
          boxState={boxstate}
          onBoxChange={setBoxState}
          BoxClick={BoxClick}
          sucursales={permisos}
          titulo_filtro="FILTRO"
          setCargarVentas={setCargarVentas}
          tipoReporte={tipo_reporte}
          tieneEscenarios={true}
          setTipoReporte={setTipoReporte}
          onEscenarioChange={setNomEscenario}
        >
          {/* {(empleado === "Guadalupe Olivas Leon" ||
            empleado === "Arnoldo  Reyes Rios" ||
            empleado === "Carlos Ivan  Lopez Castro" ||
            empleado === "Mauricio David Rodriguez Dominguez" ||
            empleado === "David Tamayo Alvarado" ||
            empleado === "Armando  Guerrero Hernandez" ||
            empleado === "Martín Alberto  Zazueta Beltrán" ||
            empleado === "David Tamayo De Saracho") && ( */}
          {/* )} */}
        </FiltroER>
      </div>
      {/* <div className="estado-resultado-visualizacion">
        <div className='estado-resultados-visualizacion-button'
          onClick={() => toggleVisualizacion()}
        >
          {visualizacion === "1" && (
            <>
              <BarChartIcon />
              <span>Mostrar Gráfica</span>
            </>
          )}
          {visualizacion === "2" && (
            <>
              <FormatListBulletedIcon />
              <span>Mostrar Detalle</span>
            </>
          )}
        </div>
      </div> */}
      <div className="buttons">
        {state.data.length < 1 || mostrarVentas === true ? (
          <div></div>
        ) : (
          <>
            <button className="excel" onClick={() => onGeneraExcel()}>
              Excel
            </button>

            <button className="PDF" onClick={() => PDFDownloadButton()}>
              PDF
            </button>
          </>
        )}
        <button className="ayuda" onClick={() => handleOpenModal()}>
          <HelpOutlineOutlinedIcon />  Ayuda
        </button>
      </div>
      {mostrarVentas === true ? (
        <div>
          <ERProyeccionesVentasScreen
            boxstate={boxstate}
            setTituloVentas={setTitulo}
            cargarVentas={cargarVentas}
            setCargarVentas={setCargarVentas}
            nomescenario={nomEscenario}
          />
        </div>
      ) : (
        <>
          {visualizacion === "2" ? (
            <div></div>
          ) : (
            state.data != undefined &&
            state.data != null &&
            state.data.length > 0 && (
              <>
                <div className="estado-resultados-header">
                  <div className="subtitulo">{subtitulo.toUpperCase()}</div>
                </div>
                <div id="comparativa-gastos-proyeccion-tipo" className="scroll-4">

                  <table
                    className="table-informacion-estado-resultados"
                    cellSpacing={0}
                    id="tabla-sticky"
                  >
                    <thead>
                      <tr
                        style={
                          {
                            //textTransform: "uppercase",
                          }
                        }
                        className="tr-encabezado1"
                      >
                        <th className="bl sticky-col-h-30"></th>
                        <th colSpan={7} className="bl sticky-col-h-30">
                          <div>{capitalizeWords(state.periodoactual)}</div>
                          {/* {GetMonthNameByNumber(boxstate.periodoinicio)} -{" "}
                  {boxstate.ejercicioinicio} */}
                        </th>
                        <th colSpan={4} className="bl sticky-col-h-30">
                          <div>{capitalizeWords(state.periodoanterior)}</div>
                          {/* {GetMonthNameByNumber(boxstate.periodofin)} -{" "}
                  {boxstate.ejerciciofin} */}
                        </th>
                      </tr>
                      <tr className="tr-down">
                        <th
                          className="bl sticky-col-h-1"
                          style={{ minWidth: "150px" }}
                        >
                          Concepto
                        </th>
                        <th
                          className="bl-separator sticky-col-h-1"
                          style={{ minWidth: "80px" }}
                        >
                          <div> Real</div>
                        </th>
                        <th className="sticky-col-h-1" style={{ minWidth: "20px" }}>
                        </th>
                        <th className="sticky-col-h-1" style={{ minWidth: "60px" }}>
                          %
                        </th>
                        <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                          <div>Proyección</div>
                        </th>
                        <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                          %
                        </th>
                        <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                          <div> Desviación</div>
                        </th>
                        <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                          %
                        </th>
                        <th
                          className="sticky-col-h-1 bl-separator"
                          style={{ minWidth: "80px" }}
                        >
                          <div> Real</div>
                        </th>
                        <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                          %
                        </th>
                        {/* <th className='sticky-col-h-1' style={{ minWidth: '80px' }}>Proyeccion</th>
                                        <th className='sticky-col-h-1' style={{ minWidth: '80px' }}>%</th> */}
                        <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                          <div>Desviación</div>
                        </th>
                        <th className="sticky-col-h-1" style={{ minWidth: "80px" }}>
                          %
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {JSON.stringify(state.data)} */}
                      {state.data.map((item) => (
                        <>
                          <tr>
                            <td className="bl br depto-title" colSpan={13}>
                              {item.depto}
                            </td>
                          </tr>
                          {item.data.map((obj) => (
                            <tr className="row-estado-resultados-detalle">
                              <td className={`bl ${obj.clase}`}>{obj.concepto}</td>
                              <td
                                className={`bl ta-right ${obj.clase} ${obj.importe < 0 ? "fcolor-red" : ""
                                  }`}
                              >
                                {FormatMoney(obj.importe)}
                              </td>
                              <td className="ta-center">
                                <span className={`indicador ${getIndicadorClass(obj.indicador)}`}></span>
                              </td>
                              <td
                                className={`ta-right ${obj.clase} ${obj.por < 0 ? "fcolor-red" : ""
                                  }`}
                              >
                                {FormatMoney(obj.por)} %
                              </td>
                              <td className={`ta-right ${obj.clase} `}>
                                {FormatMoney(obj.proyimporte)}
                              </td>
                              <td className={`ta-right ${obj.clase} `}>
                                {FormatMoney(obj.proypor)} %
                              </td>
                              <td className={`ta-right ${obj.clase} `}>
                                {FormatMoney(obj.diffimporte)}
                              </td>
                              <td className={`ta-right ${obj.clase} pr-5 `}>
                                {FormatMoney(obj.diffpor)} %{" "}
                              </td>
                              <td
                                className={`ta-right ${obj.clase} bl ${obj.lastimporte < 0 ? "fcolor-red" : ""
                                  }`}
                              >
                                {FormatMoney(obj.lastimporte)}
                              </td>
                              <td
                                className={`ta-right ${obj.clase} ${obj.lastpor < 0 ? "fcolor-red" : ""
                                  }`}
                              >
                                {FormatMoney(obj.lastpor)} %
                              </td>
                              {/* <td className={`ta-right ${obj.clase}`}>{FormatMoney(obj.lastporyimporte)}</td>
                                                            <td className={`ta-right ${obj.clase}`}>{FormatMoney(obj.lastproypor)} %</td> */}
                              <td className={`ta-right ${obj.clase} `}>
                                {FormatMoney(obj.lastdiffimporte)}
                              </td>
                              <td className={`ta-right ${obj.clase} br `}>
                                {FormatMoney(obj.lastdiffpor)} %
                              </td>
                            </tr>
                          ))}
                          <tr className="separator">
                            <td colSpan={13}></td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )
          )}

          {visualizacion.visualizacion === "1" ? (
            <div></div>
          ) : (
            infoGrafica != undefined &&
            infoGrafica != null &&
            infoGrafica.length > 0 && (
              <EstadoResultadosGrafica
                data={infoGrafica}
                ejercicio={state.periodoactual}
                ejerciciofin={state.periodoanterior}
              />
            )
          )}
        </>
      )
      }
      <AyudaModal
        open={openModal}
        onClose={handleCloseModal}
        seccion={seccion}
      />
    </PlantillaScreen >
  );
};
